import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=228b8fb5&"
import script from "./Finances.vue?vue&type=script&lang=js&"
export * from "./Finances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Finances.vue"
export default component.exports